export const skyblue = '#F1F7FF';
export const black = '#212121';
export const grey = {
  light: '#959595',
  main: '#605E5E',
  dark: '#545454',
  lighter: '#A9A7A7',
  placeholder: '#605E5EB3'
};
export const whiteUnderBox = '#F5F5F5';
export const whiteBox = '#FEFEFE';
export const white = '#FFFFFF';

export const primaryBlue = '#0000FF';
export const primaryBlueLighter = '#0000FFB2';
export const primaryRed = '#FF0000';
export const red = '#D12C3F';
export const green = '#30EA64';
export const yellow = '#FFB822';
export const orange = '#FFA234';
export const seasons = {
  autumn: '#D78915',
  spring: '#A2D56F'
};
export const gradient = {
  main: 'linear-gradient(90deg, #0000FF 0%, #FF0000 100%)',
  blue: 'linear-gradient(90deg, #0500EF 0%, #380660 100%)',
  gold: 'linear-gradient(180deg, #FFCA3F 0%, #E4A602 100%)',
  silver: 'linear-gradient(180deg, #8B8B8B 0%, #767474 100%)',
  bronze: 'linear-gradient(180deg, #D4882E 0%, #AE6F24 100%)',
  whiteShadow:
    'linear-gradient(180deg, rgba(254, 254, 254, 0) 40%, #FEFEFE 90%)'
};
